/**
 * Generic "you're not doing this alone" reassurance card. Intentionally static
 * copy — it does not render the assigned care specialist's name/phone/photo
 * (the arrangement flow no longer fetches care-specialist data).
 */
export default function CareSpecialistCard() {
  return (
    <div className="rounded-lg border border-oat bg-oat px-8 pb-8 pt-8">
      {/* Capped at its size in the desktop side column (2/3 of the card's
          294px content box) so it doesn't balloon where the card goes full
          width. */}
      <img
        src="public/After_Illustration_Support.webp"
        alt=""
        className="mx-auto mb-4 w-2/3 max-w-[196px]"
      />
      <h3 className="text-center font-serif text-xl italic text-evergreen">
        You&apos;re not doing this alone
      </h3>
      <p className="mt-2 text-center text-sm leading-relaxed text-soil">
        You&apos;ll be assigned a dedicated care specialist to guide you through
        the entire process. They&apos;ll walk you through each step, handle all
        the paperwork, and make this process as smooth and simple as possible
        for you.
      </p>
    </div>
  );
}
